import styled from "styled-components";

export const MySaveButton = styled.button`
    font-size: 1em;
    padding: 0.3em;
    height: 2em;


    &:hover {
        background-color: rgba(0, 128, 0, 0.5);
        color: rgba(245, 245, 245);
        border: 1px solid rgba(0, 128, 0);
        border-radius: 5px;
    }
`

export const MyCancelButton = styled.button`
    font-size: 1em;
    padding: 0.3em;
    height: 2em;

    &:hover {
        background-color: rgba(236, 12, 49, 0.7);
        color: rgba(245, 245, 245);
        border: 1px solid rgba(236, 12, 49);
        border-radius: 5px;
    }
`

export const MyNewButton = styled.button`
    font-size: 1em;
    height: 2em;
    border-radius: 5px;
    border: 1px solid lightslategrey;

    padding: 0.2em, 0.5em;
    margin-bottom: 1em;

        &:hover {
        background-color: rgba(127, 255, 212, 0.5);
        color: black;
        border: 1px solid rgba(127, 255, 212);
        // border-radius: 5px;
    }
`